module.exports = __webpack_public_path__ + "img/avatar.3b79c953.gif";